<div class="period-selector">
  @for (option of options(); track option.value) {
    <button 
      type="button"
      class="period-option"
      [class.selected]="isSelected(option.value)"
      (click)="selectOption(option.value)">
      <span class="period-label">{{ option.label }}</span>
    </button>
  }
</div>
